var map = {
	"./DE.svg": "4ccf",
	"./EN.svg": "2c36",
	"./ES.svg": "ddb9",
	"./FR.svg": "5b85",
	"./IT.svg": "7952",
	"./JA.svg": "2fe6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7ce7";